<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 70 70"
        fill="none"
        width="70"
        height="70"
        class="ml-5 inline-block size-9 md:size-10 lg:size-16 xl:size-[4.5rem]">
        <g opacity="0.5">
            <path
                d="M35 0V35V70"
                stroke="url(#paint0_linear_1105_6712)"
                stroke-width="5" />
            <path
                d="M70 35H35L1.66893e-06 35"
                stroke="url(#paint1_linear_1105_6712)"
                stroke-width="5" />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_1105_6712"
                x1="43"
                y1="-14"
                x2="30"
                y2="90"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="white" />
                <stop
                    offset="1"
                    stop-color="white"
                    stop-opacity="0" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_1105_6712"
                x1="82.5"
                y1="26.5"
                x2="-21"
                y2="47.5"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="white" />
                <stop
                    offset="1"
                    stop-color="white"
                    stop-opacity="0" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script setup lang="ts"></script>
